import { theme } from '@westwing/ui-kit/Theme';
import fonts from './fonts';
import common from './common';
import widgets from './widget';

const extendedColors = {
    ...theme.colors,
    colorBackgroundGrey: '#F9F9F8', // TODO: move this to style guide / ui-kit
    colorBackgroundOverlayGrey: 'rgba( 0,0,0, 0.3)',
    colorFacebookV2: 'rgb(66, 103, 178)',
    colorProductTileBackgroundGrey: 'rgba(0, 0, 0, 0.025)',
};

// TODO: remove double fonts, just nest everything
const bellaTheme = {
    colors: extendedColors,
    ...fonts,
    fonts,
    ...common,
    ...widgets,
};

export type ThemeInterface = typeof bellaTheme;

export type Color = keyof typeof extendedColors;

export default bellaTheme;
